<template>
  <b-card no-body>
      <b-card-header>
        <b-form inline>
          <worker-select
            id="worker-select"
            ref="worker_select"
            class="ml-2 mr-2 flex-fill"
            :is-disabled="isDisabled"
            v-on:onSelect="onSelect"
          />
          <b-button
            variant="success"
            size="sm"
            :disabled="isDisabled || !selectedWorkerId"
            @click="onAdd(selectedWorkerId)"
          >
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-form>
      </b-card-header>
      <b-table
        id="location-workers"
        ref="location-workers"
        class="mb-0"
        striped
        small
        thead-class="top-fixed-thead thead-light"
        table-class="text-small"
        responsive
        show-empty
        :busy.sync="isBusy"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :empty-text="$t('message.common.emptyTable')"
      >
        <template #table-busy>
          <div class="text-center text-success my-2">
            <b-spinner class="align-middle"/>
            <strong>Загрузка</strong>
          </div>
        </template>
        <template #cell(name)="row">
          {{row.item.name}}
        </template>

        <template #cell(action)="row">
          <b-button
            variant="danger"
            size="sm"
            :disabled="isDisabled"
            @click="onRemove(row.item)"
          >
            <font-awesome-icon icon="trash"/>
          </b-button>
        </template>
      </b-table>
  </b-card>
</template>

<script>
import locations from "../../network/locations";
import WorkerSelect from "../Workers/WorkerSelect";
import helpers from "../../utilites/helpers";

export default {
  name: "LocationWorkers",
  mixins: [
    locations, helpers
  ],
  components: { WorkerSelect },
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      items: [],
      fields: [
        {
          key: 'worker.name',
          label: 'ФИО',
        },
        {
          key: 'worker.phone',
          label: 'Телефон',
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'widthAction'
        },
      ],
      currentPage: 1,
      perPage: 40,
      isBusy: false,
      selectedWorkerId: null
    }
  },
  methods: {
    configure(locationId) {
      this.locationId = locationId;
      this.getItems();

      this.configureWorkerSelect();
    },
    configureWorkerSelect() {
      if (this.$refs.worker_select != null) {
        this.$refs.worker_select.configure(0, this.locationId);
      }
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getLocationWorkers(this.locationId);
      this.isBusy = false;

      if (result.data == null) { return; }
      this.items = result.data;
    },
    onSelect(id) {
      this.selectedWorkerId = id;
    },
    async onRemove(item) {
      if (item.id == null) { return; }

      const title = "Удаление исполнителя из объекта";
      const message = `Вы уверены, что хотите удалить исполнителя: ${item.worker.name}?`;
      this.showModalDelete(title, message, async function () {
        await this.onDelete(item.id);
      }.bind(this));
    },
    async onDelete(id) {
      this.isBusy = true;
      const result = await this.deleteLocationWorker(id);
      this.isBusy = false;

      if (result.data == null) { return;}

      this.configureWorkerSelect();
      await this.getItems();
    },
    async onAdd(id) {
      if (id == null) { return; }

      const data = {
        location_id: this.locationId,
        worker_id: id
      }
      this.isBusy = true;
      const result = await this.postLocationWorker(data);
      this.isBusy = false;

      if (result.data == null) { return; }

      this.$refs.worker_select.onClear();

      await this.getItems();
    },
  }
}
</script>

<style scoped>
.widthAction {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorkers.vue